import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=6fee7d8c&scoped=true&"
import script from "./SideBar.vue?vue&type=script&lang=js&"
export * from "./SideBar.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/side-bar.scss?vue&type=style&index=0&id=6fee7d8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fee7d8c",
  null
  
)

export default component.exports